import styled from '@emotion/styled';
import { useProgressContext } from '@lib/pimster-stories/contexts/ProgressContext';
import { useMemo } from 'react';

import ProgressLine from './ProgressLine';

const ProgressArrayContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-block-start: ${({ theme }) => theme.spacing.sm};
    padding-inline: ${({ theme }) => theme.spacing.sm};
    filter: drop-shadow(0 1px 8px #222);
`;

const ProgressArray = () => {
    const { numberOfPages } = useProgressContext();
    const list: number[] = useMemo(
        () => Array(numberOfPages).fill(0),
        [numberOfPages]
    );

    return (
        <ProgressArrayContainer>
            {list.map((_, index) => (
                <ProgressLine key={index} index={index} />
            ))}
        </ProgressArrayContainer>
    );
};

export default ProgressArray;
